import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { green, amber, red } from '@mui/material/colors';
import { MAPPING_KEYS } from './constant';
import { DeviceHealthStatus } from './types';

const deviceHealthIconStatusColors = {
  [DeviceHealthStatus.VERY_GOOD]: {
    background: green[50],
    text: '#2E7D32',
    icon: '#2E7D32',
  },
  [DeviceHealthStatus.GOOD]: {
    background: green[50],
    text: '#c3cb6f',
    icon: '#c3cb6f',
  },
  [DeviceHealthStatus.AVERAGE]: {
    background: amber[50],
    text: '#FFA60F',
    icon: '#FFA60F',
  },
  [DeviceHealthStatus.POOR]: {
    background: amber[50],
    text: '#ff9a3c',
    icon: '#ff9a3c',
  },
  [DeviceHealthStatus.VERY_POOR]: {
    background: red[50],
    text: '#C9252D',
    icon: '#C9252D',
  },
};

const HeartIconContainer = ({
  performance,
  tooltipTitle,
  onClickIcon = () => {},
}: {
  performance: string;
  tooltipTitle: string;
  onClickIcon?: () => void;
}) => {
  const performanceKey = MAPPING_KEYS[performance?.toUpperCase()];
  const statusColors =
    deviceHealthIconStatusColors?.[performanceKey.toUpperCase() || ''];

  return (
    <Box>
      <Tooltip arrow title={tooltipTitle}>
        <Box display="flex" onClick={onClickIcon}>
          <HeartIcon color={statusColors?.icon} />
        </Box>
      </Tooltip>
    </Box>
  );
};

const HeartIcon = ({ color }: { color: string }) => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24">
      <defs>
        <clipPath id="clip-Healthgreen">
          <rect width="25" height="24" />
        </clipPath>
      </defs>
      <g id="Healthgreen" clip-path="url(#clip-Healthgreen)">
        <rect width="25" height="24" fill="transparent" />
        <path
          id="Path_431"
          data-name="Path 431"
          d="M1386.619,2137.346a7.279,7.279,0,0,1,6.362-10.77,5.5,5.5,0,0,1,4.456,1.691c.167.143,2.073-2.12,5.433-1.691a7.182,7.182,0,0,1,4.933,2.883,7.33,7.33,0,0,1,1.429,4.456c-.167,2.407-.6,3.027-.858,3.431s-10.937,11.176-10.937,11.176l-9.579-9.555H1391l2.359-4.051,2.406,7.267,3.121-5.48,1.311,2.264h3.312s1.168-.643,0-1.621c-1.768-.016-.982.021-2.407,0-.262-.262-2.216-3.836-2.216-3.836l-2.716,4.742-2.383-7.22-3.694,6.314Z"
          transform="translate(-1384.713 -2125.521)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default HeartIconContainer;
